/*
 * That function unfocus from any input
 */
export function unfocus(): void {
	document.body.focus();
}
